<template>
  <div
    class="full-width row justify-between no-wrap items-center bg-secondary text-white q-px-md"
    style="height: 50px;"
    :style="{
      zIndex: recordPaused ? 9999 : 9,
    }"
  >
    <div class="record-status-wrapper row items-center text-caption">
      <span
        class="status-dot"
        :class="{
          'status-dot-pause': recordPaused,
        }"
      ></span>
      <span v-if="requestRecordPermissionSuccess">
        {{
          recInfo
            ? recordPaused
              ? "已暂停"
              : "对话正在录音中"
            : "请开启录音权限"
        }}
      </span>
      <div v-else>
        您已禁用该站点的麦克风权限
      </div>
    </div>

    <Timer class="q-mr-xl" :duration="(recInfo || {}).bufferDuration" />
    <div
      class="record-control fixed"
      :class="{
        'record-control-pause': recordPaused,
      }"
      @click="recordPaused ? resumeRecord() : pauseRecord()"
    >
      <q-icon :name="`fas fa-${recordPaused ? 'play' : 'pause'}`" />
      <div
        v-if="requestRecordPermissionSuccess"
        :class="{
          'q-mt-md': recordPaused,
        }"
      >
        <span v-if="recordPaused && recInfo">
          问卷已暂停，单击空白处以继续
        </span>
        <span v-else-if="recordPaused">
          请开启录音权限以开始调查
        </span>
      </div>

      <div v-else class="q-mt-md">
        <p class="full-width text-center">请开启录音权限</p>
        <p class="text-normal" style="font-size: 0.9rem;font-weight: normal">
          <br />
          Chrome浏览器开启录音权限:
          <br />
          <q-item dense class="q-px-none q-mt-sm">
            1、打开 <span class="text-primary q-px-xs">浏览器设置</span>
            <span class="text-caption text-grey">
              （右上角菜单
              <span class="bg-grey-2 q-pa-xs rounded-borders">
                <q-icon
                  name="fas fa-ellipsis-v"
                  size="10px"
                  class="text-primary"
                />
              </span>
              ）
            </span>
          </q-item>

          <q-item dense class="q-px-none q-mt-xs">
            2、在设置中进入 <span class="text-primary q-px-xs">网站设置</span>
          </q-item>

          <q-item dense class="q-px-none q-mt-xs">
            3、在网站设置中选择
            <span class="text-primary q-px-xs">
              <q-icon size="12px" class="q-mr-xs" name="fas fa-microphone" />
              <span>麦克风</span>
            </span>
          </q-item>

          <q-item dense class="q-px-none q-mt-xs">
            4、找到当前站点
            <span class="text-primary q-px-xs"> {{ origin }} </span>，
            将权限设置为 <span class="text-primary q-px-xs">允许</span>
          </q-item>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import VoiceRecorderMixin from "../../../../mixins/voice.mixin";
import {
  STOP_VOICE_RECORDER_AND_UPLOAD,
  VOICE_RECORDER_UPLOADED,
} from "@/bus/member.events";
import { EventBus } from "../../../../bus";
import { styleLog } from "../../../../utils/style-log";
import { uploadVoice } from "../../../../api/endpoints/voice/uploadVoice";
export default {
  mixins: [VoiceRecorderMixin],
  components: {
    Timer: () => import("./Timer"),
  },
  data() {
    return {
      requestRecordPermissionSuccess: false,
      cacheLocalUrl: null,
    };
  },

  mounted() {
    this.record();
    EventBus.$on(STOP_VOICE_RECORDER_AND_UPLOAD, this.resolveUpload);
  },
  beforeDestroy() {
    EventBus.$off(STOP_VOICE_RECORDER_AND_UPLOAD, this.resolveUpload);
  },

  methods: {
    record() {
      this.requestPermission(
        this.beforeRecord,
        this.onRecordRefused,
        this.recordErrorHandler
      );
    },

    /**
     * 录音开始前的准备
     */
    beforeRecord() {
      this.requestRecordPermissionSuccess = true;
      this.startRecord();
    },

    /**
     * 录音权限被拒绝
     */
    onRecordRefused() {
      console.log("refused");
      this.requestRecordPermissionSuccess = false;
    },

    /**
     * 录音出现错误
     */
    recordErrorHandler(errorMsg) {
      this.$q.notify({
        type: "danger",
        message: `${errorMsg}, 录音失败`,
      });
    },

    async resolveUpload(sample) {
      styleLog.successPrefix("停止录音");
      try {
        await this.stopRecord();
      } catch (err) {}
      const { voiceBlob } = this;
      if (!voiceBlob) return;
      const form = new FormData();
      form.append("voice", voiceBlob, `${this.$route.params.sample_id}.mp3`);
      styleLog.successPrefix("开始上传录音文件");

      try {
        if (this.cacheLocalUrl) {
          (window.URL || webkitURL).revokeObjectURL(this.cacheLocalUrl);
        }
        this.cacheLocalUrl = (window.URL || webkitURL).createObjectURL(
          this.voiceBlob
        );
        const a = document.createElement("a");
        a.href = this.cacheLocalUrl;
        a.download = `${sample.detail.name}_${new Date().toLocaleString()}.mp3`;
        a.target = "_blank";
        a.click();
      } catch (err) {}
      try {
        await uploadVoice(this.$route.params.sample_id, form);
        EventBus.$emit(VOICE_RECORDER_UPLOADED, true);
      } catch (err) {
        EventBus.$emit(VOICE_RECORDER_UPLOADED, false);
      }
    },
  },

  computed: {
    origin() {
      const url = window.location.href;
      const a = document.createElement("a");
      a.href = url;
      return a.origin;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.status-dot {
  width: 16px;
  height: 16px;
  background-color: red;
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;

  &.status-dot-pause {
    background-color: $grey-5;
  }
}

.record-control {
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.1);
  right: 10px;
  bottom: 10px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 0.7rem;
  transition: all 0.23s ease;
  user-select: none;

  &.record-control-pause {
    width: 100vw;
    height: 100vh;
    right: 0;
    bottom: 0;
    border-radius: 0;
    background-color: rgba(255, 255, 255, 0.9);
    color: $grey-7;
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>
